import { Pipe, PipeTransform } from "@angular/core";

/**
 * @description accepts any aribatrary function declaratively.
 */
@Pipe({
    name: "accessorPipe",
    standalone: false
})
export class PropertyAccessorPipe implements PipeTransform{
  transform(value: any, propertyAccessor: (any) => string) {
    return propertyAccessor(value);   
  }
 
}
